import { BHTTPLoader } from '../service/bHTTPLoader';
var spinnerComponent = (function () {
    function spinnerComponent(bHTTPLoader) {
        var _this = this;
        this.bHTTPLoader = bHTTPLoader;
        bHTTPLoader._isHTTPRequestInProgress$.subscribe(function (res) {
            _this.isHTTPRequestInProgress = res;
            // console.info("isHTTPRequestInProgress : "+res);
        });
    }
    return spinnerComponent;
}());
export { spinnerComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/spinnerComponent/spinner.component.ts.pre-build-optimizer.js